import {
  getRefreshToken,
  handleLogin,
  logout,
} from "../../shared/constants/login-store";
import { refreshAuth } from "../api/auth-api";
import { setRedirectUrl } from "../../shared/constants/redirect-store";

let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRefreshed(token) {
  subscribers.map((cb) => cb(token));
  subscribers = [];
}

export const refreshToken = (client, originalRequest) => {
  if (!isRefreshing) {
    isRefreshing = true;

    const storedRefreshToken = getRefreshToken();

    // No refresh token to send (e.g. already logged out/expired session) -
    // calling refreshAuth(null) would just fail and, worse, could redirect
    // to /auth in a loop. Bail out straight to logout/redirect instead.
    if (!storedRefreshToken) {
      isRefreshing = false;
      return redirectToLogin();
    }

    return refreshAuth(storedRefreshToken)
      .then((response) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      })
      .then((data) => {
        console.log("Got Tokens by Update Token");
        handleLogin(data);
        isRefreshing = false;
        onRefreshed(data.accessToken);
        originalRequest.headers["Authorization"] = data.accessToken;
        return client(originalRequest);
      })
      .catch((e) => {
        isRefreshing = false;
        return redirectToLogin(e);
      });
  }

  return new Promise((resolve) => {
    subscribeTokenRefresh((token) => {
      originalRequest.headers.Authorization = `Bearer ${token}`;
      resolve(client(originalRequest));
    });
  });
};

function redirectToLogin(e) {
  logout();

  // Avoid redirect loops: only redirect if we're not already on /auth or /logout.
  // - /auth page handles its own navigation after completing auth flow
  // - /logout page handles its own navigation to /login after logout completes
  const currentPath = window.location.pathname;
  if (currentPath !== "/auth" && currentPath !== "/logout") {
    setRedirectUrl(currentPath + window.location.search);
    window.location = "/login";
  }

  return Promise.reject(e);
}
